import axios from 'axios'
import store from '../store/index.js'
import dialogService from './dialogService'

const generateHeaders = () => {
  let Authorization = 'Bearer ';
  let token = store.state.user.token || '';
  console.log('store: ', store.state.user)
  console.log('token: ', token)
  return {
    'Content-Type': 'application/json',
    Authorization: Authorization + token
  }
}

const httpService = input =>{
  if (input.method !== 'get' && input.method !== undefined && input.loading === undefined) {
    store.commit('system/updateHttpLoading',true)
  }
  input.url = /^http:\/\/|^https:\/\//.test(input.url) ?input.url : (window.api || '') + input.url;
  console.log('input.url', input.url)
  // input.url = 'http://localhost:81'+ input.url
  input.url = 'https://gzh.xjddjyz.cn'+ input.url // http://xjddf.conjure.net.cn
  // input.url = 'http://xjddi.conjure.net.cn'+ input.url
  input.headers = Object.assign(generateHeaders(), input.headers);
  return new Promise(resolve => {
    axios({
      url: input.url,
      timeout: 30000,
      data: input.body,
      params: input.params,
      headers: input.headers,
      method: input.method || 'get',
      onUploadProgress:input.methods//上传文件进度
    })
      .then(res => {
        store.commit('system/updateHttpLoading', false);
        if(res.status===999){
          dialogService.toast('你的账号已被禁用')
        }
        resolve(res.data);
      })
      .catch(err => {
        if (err.code === 'ECONNABORTED') {
          dialogService.toast('请求超时，请检查您的网络')
        }
        else if (err.response.status === 401) {
          // 跳转到登录
          dialogService.toast('您的登陆凭证已过期',function () {
            store.commit('user/setToken',null);//清除用户信息
            store.commit('user/setUserInfo',{});//清除用户信息
            location.href = 'http://'+window.host+'/api/oauth?user_id=0&redirect=/mine';
          });

        } else if (err.response.status === 500) {
          // debugger
          dialogService.toast('服务器内部错误,请稍后再试')
        } else {
          resolve(err.data)
        }
      })
  })
};

httpService.get = (url, params) => {
  return httpService({
    url,
    params
  })
};


httpService.post = (url, params,loading) => {
  return httpService({
    url,
    body: params,
    method: 'post',
    loading
  })
};

httpService.postQuery = (url, params) => {
  return httpService({
    url,
    params,
    method: 'post',
  })
};

httpService.delete = (url, params) => {
  return httpService({
    url,
    body: params,
    method: 'delete',
  })
}

httpService.put = (url, params,) => {
  return httpService({
    url,
    body: params,
    method: 'put'
  })
}
export default httpService



// WEBPACK FOOTER //
// ./src/service/httpService.js